import React from "react";
import { Link } from "react-router-dom";

export default function NavbarMenu() {
  return (
    <nav className="w-full fixed top-0 left-0 z-50 bg-black/25 backdrop-blur-md border-b border-white/5 h-20 flex items-center">
      <div className="max-w-6xl mx-auto px-6 w-full flex justify-between items-center">

        {/* LOGO */}
        <img 
          src="/Delis.png"
          alt="Delis Logo"
          className="w-32 md:w-40 drop-shadow-[0_2px_8px_rgba(255,255,255,0.2)]"
        />

        {/* LINKS */}
        <div className="flex items-center gap-8 text-white text-lg font-medium">
          <Link to="/" className="hover:text-orange-400 transition">Inicio</Link>
          <Link to="/menu" className="hover:text-orange-400 transition">Menú</Link>
        </div>

      </div>
    </nav>
  );
}
